<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<router-outlet></router-outlet>
